var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { BasePartner } from '../BasePartner';
import ResultsCard from '../../../ResultsCard/ResultsCard';
import VirtualVisitOptions from '../../../../clearstep/VirtualVisitOptions/VirtualVisitOptions';
import { VirtualVisitCareOptionIcon } from '../../../../svg/VirtualVisitCareOptionIcon';
import SectionHeader from '../../../../clearstep/SectionHeader/SectionHeader';
import { SourceOfCare } from '../../../../clearstep/proto/results_pb';
/* eslint-disable class-methods-use-this */
/* eslint-disable react/jsx-no-literals */
/*
  disabling jsx-no-literals as this file is not currently used
  for any partners that require translation
*/
var ClearstepPartner = /** @class */ (function (_super) {
    __extends(ClearstepPartner, _super);
    function ClearstepPartner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClearstepPartner.prototype.homeCareProviderOption = function () {
        return (React.createElement("div", { className: "mt-10" },
            React.createElement(SectionHeader, { text: "Still want to talk to a healthcare provider?" }),
            React.createElement(ResultsCard, null,
                React.createElement("div", { className: "flex flex-row items-center pb-4" },
                    React.createElement("div", { className: "flex flex-col justify-center pr-4" },
                        React.createElement(VirtualVisitCareOptionIcon, null)),
                    React.createElement("h4", { className: "text-left text-xl font-bold leading-7 mobile:text-lg mobile:leading-6.5" }, "Virtual Doctor Visit")),
                React.createElement("p", null, "A virtual visit with a healthcare provider (often referred to as telemedicine or telehealth) is a convenient, and often more affordable alternative to an in-person visit. A primary care provider will meet with you over video via your smartphone, tablet, or computer, and may refer you to a specialist for additional care, if appropriate."),
                React.createElement(VirtualVisitOptions, null))));
    };
    ClearstepPartner.prototype.showCareOptionDescription = function (options) {
        var careType = options.careType, careDetails = options.careDetails;
        if (careType === SourceOfCare.Type.SPECIALIST && careDetails)
            return false;
        return true;
    };
    ClearstepPartner.prototype.careOptionsSubheader = function () {
        return 'Enter information below to find care near you';
    };
    ClearstepPartner.prototype.careOptionCost = function () {
        return null;
    };
    return ClearstepPartner;
}(BasePartner));
export { ClearstepPartner };
